import ErrorIcon from '@mui/icons-material/Error';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import type { ErrorStepProps } from '../types';

export function ErrorStep({ error }: ErrorStepProps) {
  const { t } = useTranslation();

  return (
    <Box sx={{ textAlign: 'center', py: 2 }}>
      <ErrorIcon sx={{ fontSize: 64, color: 'error.main', mb: 2 }} />
      <Typography variant="h6" color="error">
        {t('signature.errorTitle')}
      </Typography>
      {error && (
        <Typography
          variant="body2"
          sx={{
            color: 'text.secondary',
            mt: 1,
          }}
        >
          {error}
        </Typography>
      )}
    </Box>
  );
}
